<mat-card>{{'orderByProductStatment' | translate}}</mat-card>



<div class="container" style="padding: 25px;">

    <mat-grid-list cols="6" rowHeight="50px">

        <mat-grid-tile colspan="1">
            <mat-form-field appearance="standard">
                <mat-label>{{'status' | translate}}</mat-label>
                <mat-select [(value)]="selectedStatus">
                    <mat-option [value]="1"> مباع </mat-option>
                    <mat-option [value]="0"> غير مباع </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="fill" class="example-form-field" style="margin: 10px;">
                <mat-label>{{'category' | translate}}</mat-label>
                <mat-select [(value)]="selectedCategory" (selectionChange)="onCategoryChange()">
                    <mat-option *ngFor="let item of category" [value]="item.id">
                        {{item.arabicName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="3">
            <mat-form-field appearance="fill" class="example-form-field" style="margin: 10px;;">
                <mat-label>{{'subCategory' | translate}}</mat-label>
                <mat-select [(value)]="selectedSubCategory" (selectionChange)="onsubCategoryChange()">
                    <mat-option *ngFor="let item of subCategories" [value]="item.id">
                        {{item.arabicName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="fill" class="example-form-field" style="margin: 10px;;">
                <mat-label>{{'product' | translate}}</mat-label>
                <mat-select [(value)]="selectedProduct">
                    <mat-option *ngFor="let item of products" [value]="item.id">
                        {{item.arabicName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="fill" class="example-form-field">
                <mat-label>{{'createDate' | translate}}</mat-label>
                <mat-date-range-input [rangePicker]="rangePicker">
                    <input matStartDate placeholder="Start date" #fromDate>
                    <input matEndDate placeholder="End date" #toDate>
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #rangePicker>
                    <mat-date-range-picker-actions>
                        <button mat-button matDateRangePickerCancel>{{'cancel' | translate}}</button>
                        <button mat-raised-button color="primary" (click)="onApply()" matDateRangePickerApply>
                            {{'filter' | translate}}</button>
                    </mat-date-range-picker-actions>
                </mat-date-range-picker>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2" *ngIf="selectedStatus == 1">
            <mat-form-field appearance="fill" class="example-form-field">
                <mat-label>{{'enterDateRangeOfSale' | translate}}</mat-label>
                <mat-date-range-input [rangePicker]="rangePicker1">
                    <input matStartDate placeholder="Start date" #fromDateOfSale>
                    <input matEndDate placeholder="End date" #toDateOfSale>
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="rangePicker1"></mat-datepicker-toggle>
                <mat-date-range-picker #rangePicker1>
                    <mat-date-range-picker-actions>
                        <button mat-button matDateRangePickerCancel>{{'cancel' | translate}}</button>
                        <button mat-raised-button color="primary" (click)="onApply()" matDateRangePickerApply>
                            {{'filter' | translate}}</button>
                    </mat-date-range-picker-actions>
                </mat-date-range-picker>
            </mat-form-field>
        </mat-grid-tile>


        <mat-grid-tile colspan="6">

            <button mat-raised-button color="primary" (click)="onApply()" style="margin-left: 10px;">
                <mat-icon>search</mat-icon>
                {{'filter' | translate}}
            </button>
            <button mat-raised-button color="primary" [disabled]="reports.length == 0" style="margin-left: 10px;"
                (click)="exporter.exportTable('xlsx')">
                <mat-icon>print</mat-icon>
                {{'print' | translate}}
            </button>

            <button mat-raised-button color="primary" [disabled]="reports.length == 0" (click)="exportAsXLSX()">
                <mat-icon>import_export</mat-icon>
                {{'exportExcel' | translate}}
            </button>

        </mat-grid-tile>



    </mat-grid-list>

    <div class="mat-elevation-z8">
        <table mat-table matTableExporter #exporter="matTableExporter" [dataSource]="dataSource" matSort
            id="productCardTable">

            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'id' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
            </ng-container>

            <ng-container matColumnDef="CardsNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'cardNo' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.cardNumber}} </td>
            </ng-container>

            <ng-container matColumnDef="serialNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'serialNo' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.serialNumber}} </td>
            </ng-container>

            <ng-container matColumnDef="expiryDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'expiry' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.expiryDate | date: 'dd/MM/yyyy hh:mm'}} </td>
            </ng-container>



            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}}"</td>
            </tr>
        </table>

        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

</div>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>